import React, {useState, useEffect} from 'react';
import Card from './Card';
import Data from '../data/home';


function Home(props) {
    const [homeData, setHomeData] = useState(Data);
    const [cardData, setCardData] = useState([]);
        return ( 
            <>
                <div className="container" style={{ marginTop: '30px' }}>
                    <div className="row">
                        <div className="col-lg-12 mb-4 mt-2 text-center">
                        {homeData?.marketing && ( // Check if homeData and homeData.marketing are defined
                    <div className="container ">
                        <div className="row">
                            { 
                                homeData.marketing.map( (marketing, index) => {
                                    if (index > 6 && index < 9 && marketing) { // Check if marketing is defined
                                        return (
                                            <Card 
                                                title={ marketing.title } 
                                                image={ marketing.image } 
                                                body={ marketing.body } 
                                                url={ marketing.url } 
                                                key={ 'infotile_' + marketing.id }
                                            ></Card>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                )}
                        </div>
                    </div>
                </div>
            </>
        );
    }
export default Home;